import React from 'react';
import { Box, Typography, Card, Grid } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import './openRoles.css';
import OrangeButton from '../../buttons/orange-button';
import OrangeButtonOutline from '../../buttons/orange-button-outline';
import { useNavigate } from 'react-router-dom';
const rolesData = [
  {
    title: 'Test Automation Developer',
    description: 'Engineering | Full time, Remote',
  },
  {
    title: 'AI Engineer',
    description: 'Engineering | Full time, Remote',
  },
  {
    title: 'Marketing Manager',
    description: 'Marketing | Full time, Remote',
  },
];

const OpenRoles = () => {
  const navigate = useNavigate();
  return (
    <Box className="bg-[#f9fafc] !py-10  text-center md:!pb-[104px] md:!pt-[60px]">
      {/* Header Section */}
      <Box className="mx-auto max-w-[606px] space-y-[14px] !px-4 pb-6 md:space-y-[16px] md:px-0 md:pb-[42px]">
        <h6 className="text-center font-[Fredoka] text-[22px] font-medium leading-[32px] tracking-[-0.22px] text-[#012E33]">
          👋 Join us
        </h6>
        <h4 className="text-center font-[Fredoka] text-[40px] font-bold leading-normal tracking-[-0.8px] text-[#012E33] ">
          Open Roles
        </h4>
        <p className=" self-stretch text-center font-[Fredoka] text-[22px] font-normal leading-[32px] tracking-[-0.22px] text-[#678285]">
          If you are interested in joining our advisory board, we would love to hear from you.
        </p>
        <div className="mx-autoitems-center flex flex-col justify-center gap-4 px-2 md:flex-row">
          <OrangeButton
            className="md:!w-[189px]"
            variant="contained"
            label={'Contact Us'}
            onClick={() => navigate('/contact')}
          />
          {/* <OrangeButtonOutline label={'See All Openings'} onClick={() => navigate('/careers')} /> */}
        </div>
      </Box>

      {/* Roles Section */}
      {/* <Grid container spacing={3} justifyContent="center" className="!px-4">
        {rolesData.map((role, index) => (
          <Grid item xs={12} key={index}>
            <Card
              className="roles-center"
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: { xs: '12px', sm: '18px' }, // Reduced padding for mobile
                borderRadius: '32px',
                maxWidth: '800px',
                backgroundColor: '#E0F7FA',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '24px',
                    width: { xs: '55px', sm: '50px', md: '65px', lg: '83px' }, // Smaller image size on mobile
                    height: { xs: '55px', sm: '50px', md: '65px', lg: '83px' },
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <img
                    src="/images/icons/grad-img.svg"
                    alt=""
                    className="h-5 w-8 md:h-[31px] md:w-[48px]"
                    style={{ width: '50%', height: 'auto' }}
                  />
                </Box>
                <Box className="!space-y-2" sx={{ textAlign: 'left' }}>
                  <Typography
                    variant="h6"
                    className="!text-[18px] !font-medium !leading-tight !tracking-[0.18px] text-[#012E33] md:!text-[22px] md:!leading-[32px] md:!tracking-[-0.22px]"
                  >
                    {role.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    className="text-base tracking-[-0.16px] text-[#678285] md:text-[18px]"
                  >
                    {role.description}
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  borderRadius: '24px',
                  border: '1px solid #044047',
                  width: { xs: '40px', sm: '50px', md: '65px', lg: '83px' }, // Smaller icon size on mobile
                  height: { xs: '40px', sm: '50px', md: '65px', lg: '83px' },
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                onClick={() => navigate('/contact')}
              >
                <ArrowForwardIosIcon
                  sx={{ color: '#003B47', fontSize: { xs: '16px', sm: '20px' } }}
                />{' '}
                {/* Adjust icon size for mobile /}
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid> */}
    </Box>
  );
};

export default OpenRoles;
